

function truncateString(string, n) {
    return string?.length > n ? `${string?.slice(0, n)}...` : string;
};

export default truncateString;